import type { StageContentData } from '@/types/stage-content-api.types';

import gameMetadata from '../data/game-metadata.json';

export const stageContentApi = {
  getStageContent: (
    _adminBaseUrl: string,
    _stageId: string,
    lang: string,
  ): Promise<StageContentData> => {
    // Return the content from the local metadata file for the specified language
    // Falls back to English (EN) if the requested language is not found
    const content = gameMetadata.stage_content.find((sc) => sc.language === lang) || gameMetadata.stage_content.find((sc) => sc.language === 'EN');
    
    if (!content) {
      return Promise.reject(new Error('Stage content not found in local metadata'));
    }
    
    return Promise.resolve(content as unknown as StageContentData);
  }
};
